module.exports = __webpack_public_path__ + "media/video_08.233c1c26.mp4";